import PropTypes from 'prop-types';
import React from 'react';
import Autocomplete from '../utils/Autocomplete';

class StrategyDetails extends React.Component {
  constructor(props) {
    super(props);
    this.presets = props.presets;
  }

  loadPresets = type => {
    if (!type) {
      return [];
    }
    console.log('type', type);
    return this.props.presets.filter(p => p.CustomCriteriaPresetType.id === type);
  };

  getLabel = presets => {
    if (presets && presets.length > 0) {
      console.log('preset', presets[0].name);
      return `${presets[0].CustomCriteriaPresetType.name.replace('Aura', 'AURA')} Details`;
    }
    return '';
  };

  handleSelect = selected => {
    const evt = {
      target: {
        name: 'CustomCriteriaPresets',
        value: selected
      }
    };
    this.props.onChange(evt);
  };

  render() {
    const { value, presetType, disabled } = this.props;
    let aura = false;
    const presets = this.loadPresets(presetType);
    console.log('presets', presets[0]);
    if (presets && presets[0] && presets[0].CustomCriteriaPresetType.name === 'Aura') {
      aura = true;
    }

    return (
      <Autocomplete
        disabled={disabled}
        onChange={this.handleSelect}
        value={value}
        suggestions={presets}
        name="CustomCriteriaPresets"
        suggestionKey="name"
        label={this.getLabel(presets)}
        placeholder="Select or start typing"
        aura = {aura}
      />
    );
  }
}

StrategyDetails.defaultProps = {
  value: [],
  presetType: 0
};

StrategyDetails.propTypes = {
  value: PropTypes.array,
  presets: PropTypes.arrayOf(PropTypes.object).isRequired,
  presetType: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};

export default StrategyDetails;
